import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import theme from './Theme';
import { ThemeProvider } from '@material-ui/core';
import App from './App';
import './index.css';
import 'react-circular-progressbar/dist/styles.css';
import 'mapbox-gl/dist/mapbox-gl.css';
import LoadingKucingC from './Components/LoadingKucing/';

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <Suspense fallback={<LoadingKucingC />}>
        <App />
      </Suspense>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
